import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import theme from '../../../theme';

interface Props {
  className?: string;
}

const DummyRectangle = ({ className }: ClassAttributes<HTMLElement> & Props) => <Root className={className} />;

const animation = keyframes({
  '0%': { backgroundColor: theme.palette.grey['300'] },
  '50%': { backgroundColor: theme.palette.grey['200'] },
  '100%': { backgroundColor: theme.palette.grey['300'] },
});

const Root = styled('div')({
  backgroundColor: theme.palette.grey['300'],
  borderRadius: 2,
  animationDuration: '1500ms',
  animationFillMode: 'forwards',
  animationIterationCount: 'infinite',
  animationName: animation,
  animationTimingFunction: 'linear',
});

export default DummyRectangle;
